import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

type UpdateIntroCallStatusParams = {
  request_id: string;
  status: 'accepted' | 'declined' | 'completed';
};

const useUpdateIntroCallStatus = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: UpdateIntroCallStatusParams) => {
    const { data, error } = await supabaseClient.functions.invoke('update_intro_call_status', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      // Invalidate intro call requests query to refetch
      queryClient.invalidateQueries({ queryKey: ['introCallRequests'] });
      // Invalidate all carer details queries to update has_completed_intro_call flag
      queryClient.invalidateQueries({ queryKey: ['carer'] });
    },
  });
};

export default useUpdateIntroCallStatus;
